import { fetchAuthSession } from "aws-amplify/auth";

export const getAuthToken = async (): Promise<string> => {
  try {
    const session = await fetchAuthSession();
    return session.tokens?.idToken?.toString() ?? "";
  } catch {
    return "";
  }
};

/**
 * Singleton refresh lock. Multiple concurrent 401s share one refresh attempt
 * rather than flooding Amplify's TokenOrchestrator with parallel forceRefresh calls.
 */
let refreshPromise: Promise<string> | null = null;

export const getAuthTokenWithRefresh = async (): Promise<string> => {
  // First try normal path (token may have been refreshed by another request)
  const token = await getAuthToken();
  if (token) return token;

  // Token is empty — need force refresh. Use singleton to prevent parallel calls.
  if (!refreshPromise) {
    refreshPromise = (async () => {
      try {
        const session = await fetchAuthSession({ forceRefresh: true });
        return session.tokens?.idToken?.toString() ?? "";
      } catch {
        return "";
      } finally {
        refreshPromise = null;
      }
    })();
  }
  return refreshPromise;
};
